import {combineReducers} from 'redux';

import UsuarioReducer from './UsuarioReducer';
import ProdutoReducer from './ProdutoReducer';
import CaminhoReducer from './CaminhoReducer';
import ContratoReducer from './ContratoReducer';
import ItemReducer from './ItemReducer';
import TutorialReducer from './TutorialReducer';
import FormandoReducer from './FormandoReducer';
import AcaoReducer from './AcaoReducer';
import EmailReducer from './EmailReducer';
import PublicacaoReducer from './PublicacaoReducer';
import ConviteReducer from './ConviteReducer';
import ComentarioReducer from './ComentarioReducer';

import ExemplosTextoReducer from './ExemplosTextoReducer';
import TipoContratoReducer from './TipoContratoReducer';
import UsuarioContratoReducer from './UsuarioContratoReducer';
import InstagramReducer from './InstagramReducer';
import ItemFormandoReducer from './ItemFormandoReducer';
import NomesArquivosFechamentoReducer from './NomesArquivosFechamentoReducer';
import TurmaReducer from './TurmaReducer';

export default combineReducers({
  usuario: UsuarioReducer,
  produto: ProdutoReducer,
  caminho: CaminhoReducer,
  contrato: ContratoReducer,
  item: ItemReducer,
  tutorial: TutorialReducer,
  formando: FormandoReducer,
  acoes: AcaoReducer,
  email: EmailReducer,
  publicacao: PublicacaoReducer,
  convite: ConviteReducer,
  comentario: ComentarioReducer,
  exemplosTexto: ExemplosTextoReducer,
  tipoContrato: TipoContratoReducer,
  usuarioContrato: UsuarioContratoReducer,
  instagram: InstagramReducer,
  itemFormando: ItemFormandoReducer,
  nomesArquivosFechamento: NomesArquivosFechamentoReducer,
  turmas: TurmaReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js